export const CLEAR_ACTIVE_CONTACTS = 'CLEAR_ACTIVE_CONTACTS'; // clear the state of the panel (online friends, admins/helpers, requests), not the entire reducer state
export const SET_ALL_FRIENDS_FROM_INBOUND = 'SET_ALL_FRIENDS_FROM_INBOUND';
export const SET_ACTIVE_CONTACTS_FROM_INBOUND = 'SET_ACTIVE_CONTACTS_FROM_INBOUND';
export const SET_CONTACT_ACTIVE_FROM_INBOUND = 'SET_CONTACT_ACTIVE_FROM_INBOUND';
export const SET_CONTACT_INACTIVE_FROM_INBOUND = 'SET_CONTACT_INACTIVE_FROM_INBOUND';
export const SHOW_FRIEND_REQUEST_FROM_INBOUND = 'SHOW_FRIEND_REQUEST_FROM_INBOUND';
export const HIDE_FRIEND_REQUEST_FROM_INBOUND = 'HIDE_FRIEND_REQUEST_FROM_INBOUND';
export const ADD_FRIEND_TO_ALL_FROM_INBOUND = 'ADD_FRIEND_TO_ALL_FROM_INBOUND';
export const REMOVE_FRIEND_FROM_ALL_FROM_INBOUND = 'REMOVE_FRIEND_FROM_ALL_FROM_INBOUND';
export function clearActiveContacts() {
    return {
        type: CLEAR_ACTIVE_CONTACTS
    };
}
export function setActiveContactsFromInbound(inbound) {
    return {
        type: SET_ACTIVE_CONTACTS_FROM_INBOUND,
        payload: inbound
    };
}
export function setAllFriendsFromInbound(inbound) {
    return {
        type: SET_ALL_FRIENDS_FROM_INBOUND,
        payload: inbound
    };
}
export function setContactActiveFromInbound(inbound) {
    return {
        type: SET_CONTACT_ACTIVE_FROM_INBOUND,
        payload: inbound
    };
}
export function setContactInactiveFromInbound(inbound) {
    return {
        type: SET_CONTACT_INACTIVE_FROM_INBOUND,
        payload: inbound
    };
}
export function showFriendRequestFromInbound(inbound) {
    return {
        type: SHOW_FRIEND_REQUEST_FROM_INBOUND,
        payload: inbound
    };
}
export function hideFriendRequestFromInbound(inbound) {
    return {
        type: HIDE_FRIEND_REQUEST_FROM_INBOUND,
        payload: inbound
    };
}
export function addFriendToAllFromInbound(inbound) {
    return {
        type: ADD_FRIEND_TO_ALL_FROM_INBOUND,
        payload: inbound
    };
}
export function removeFriendFromAllFromInbound(inbound) {
    return {
        type: REMOVE_FRIEND_FROM_ALL_FROM_INBOUND,
        payload: inbound
    };
}
